import { VideoCallProvider } from '@context/VideoCall';
import { useLocation } from 'react-router-dom';
import VideoCallView from '@pages/VideoCall/VideoCallView';

interface VideoCallProps {
  state?: {
    treatmentId: string;
  };
}

const VideoCall = () => {
  // 타입단언 외에 다른 방법은 없나?
  const { state } = useLocation() as VideoCallProps;

  return (
    <VideoCallProvider treatmentId={state?.treatmentId || '1'}>
      <VideoCallView />
    </VideoCallProvider>
  );
};

export default VideoCall;
